<h2 mat-dialog-title mat-dialog-draggable-title *ngIf="!isMySign">
  {{'app_mobile.title' | translate}}
  <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<h2 mat-dialog-title mat-dialog-draggable-title *ngIf="isMySign">
  {{'app_mobile.title_my_sign' | translate}}
  <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<mat-dialog-content>
  <div class="content-container">
    <span class="scan-qr" style="margin: 6px 0px 0px 0px">{{'app_mobile.scan_qr_here' | translate}}</span>
    <img class="image-qr" *ngIf="!isMySign" src="../../../../../assets/images/qrcode-app/QR-Download-App.png">
    <img class="image-qr" *ngIf="isMySign" src="../../../../../assets/images/qrcode-app/Qr_Mysign.png">
    <div class="container-or">
      <mat-divider style="width: 180px; color: #E8E8E8;"></mat-divider>
      <span class="text-or">{{'app_mobile.or' | translate}}</span>
      <mat-divider style="width: 180px; color: #E8E8E8;"></mat-divider>
    </div>
    <span class="text-copy-path">{{'app_mobile.copy_path' | translate}}</span>
    <div class="input-copy-container">
      <div class="input-copy" *ngIf="!isMySign">
        {{urlDowload}}
      </div>
      <div class="input-copy" *ngIf="isMySign">
        {{urlDowloadMysign}}
      </div>
      <div class="button-copy" (click)="copyLink()">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_6981_6211)">
            <path d="M12.1484 20H4.6875C2.96432 20 1.5625 18.5982 1.5625 16.875V6.28906C1.5625 4.56589 2.96432 3.16406 4.6875 3.16406H12.1484C13.8716 3.16406 15.2734 4.56589 15.2734 6.28906V16.875C15.2734 18.5982 13.8716 20 12.1484 20ZM4.6875 4.72656C3.82599 4.72656 3.125 5.42755 3.125 6.28906V16.875C3.125 17.7365 3.82599 18.4375 4.6875 18.4375H12.1484C13.0099 18.4375 13.7109 17.7365 13.7109 16.875V6.28906C13.7109 5.42755 13.0099 4.72656 12.1484 4.72656H4.6875ZM18.3984 14.9219V3.125C18.3984 1.40182 16.9966 0 15.2734 0H6.60156C6.17004 0 5.82031 0.349731 5.82031 0.78125C5.82031 1.21277 6.17004 1.5625 6.60156 1.5625H15.2734C16.1349 1.5625 16.8359 2.26349 16.8359 3.125V14.9219C16.8359 15.3534 17.1857 15.7031 17.6172 15.7031C18.0487 15.7031 18.3984 15.3534 18.3984 14.9219Z" fill="white"/>
          </g>
          <defs>
            <clipPath id="clip0_6981_6211">
              <rect width="20" height="20" fill="white"/>
            </clipPath>
          </defs>
        </svg>
        <span class="text-copy-button">{{'app_mobile.copy' | translate}}</span>
      </div>
    </div>
    <div class="container-store" >
      <span class="image-app-store d-flex justify-content-end" ><img style="cursor: pointer;" src="../../../../../assets/images/qrcode-app/app-store.png" alt="logoAppStore"  (click)="changeLinkStore('AppStore')"></span>
      <span class="image-app-store"><img style="cursor: pointer; width: 120px;height: auto" src="../../../../../assets/images/qrcode-app/Ch-play-dowload.png" alt="logoChPlay" (click)="changeLinkStore('ChPlay')"></span>
    </div>
  </div>
</mat-dialog-content>
